const mod = (n, m) => ((n % m) + m) % m;

export default mod;